// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.Navbar_navbar__uTQDG {
    border: none;
    border: 0px;
    margin: 0px;
    padding: 0px;
    font: 67.5% "Lucida Sans Unicode", "Bitstream Vera Sans", "Trebuchet Unicode MS", "Lucida Grande", Verdana, Helvetica,
        sans-serif;
    font-size: 18px;
    font-weight: bold;

    position: relative; /* Permite que o menu fique acima do conteúdo */
    z-index: 1000; /* Mantém o menu acima do container */
}
.Navbar_navbar__uTQDG ul {
    background: #ccc; /*#006633;*/
    height: 35px;
    list-style: none;
    margin: 0;
    padding: 0;
}
.Navbar_navbar__uTQDG li {
    float: left;
    padding: 0px;
    margin: 0;
}
.Navbar_navbar__uTQDG li a {
    background: bottom right no-repeat #ccc; /*#006633;*/
    color: #000; /*#ffffff;*/
    display: block;
    font-weight: normal;
    line-height: 35px;
    margin: 0px;
    padding: 0px 10px;
    text-align: center;
    text-decoration: none;
}
.Navbar_navbar__uTQDG li a:hover,
.Navbar_navbar__uTQDG ul li:hover a {
    background: bottom center no-repeat #1182ff;
    color: #ffffff;
    text-decoration: none;
}
.Navbar_navbar__uTQDG li ul {
    background: #0053ae;
    display: none; /* Escondido por padrão */
    height: auto;
    padding: 0px;
    margin: 0px;
    border: 0px;
    position: absolute;
    /*width:225px;*/
    z-index: 200;
    /*top:1em;
    /*left:0;*/
}

.Navbar_navbar__uTQDG li:hover ul {
    display: block;
}

.Navbar_navbar__uTQDG li li {
    background: bottom left no-repeat;
    display: block;
    float: none;
    margin: 0px;
    padding: 0px;
    /*width:225px;*/
}

.Navbar_navbar__uTQDG li:hover li a {
    background: none;
}

.Navbar_navbar__uTQDG li ul a {
    display: block;
    height: 30px;
    /*font-size:12px;*/
    font-style: normal;
    margin: 0px;
    padding: 0px 10px 0px 20px;
    text-align: left;
    color: #fff;
}

.Navbar_navbar__uTQDG li ul a:hover,
.Navbar_navbar__uTQDG li ul li:hover a {
    background: center left no-repeat #39b0e2;
    border: 0px;
    color: #fff;
    text-decoration: none;
}
.Navbar_navbar__uTQDG p {
    clear: left;
}

/* formatação do button */
.Navbar_navbar__uTQDG li button {
    background: bottom right no-repeat #ccc; /*#006633;*/
    color: #000; /*#ffffff;*/
    display: block;
    font-weight: normal;
    line-height: 35px;
    margin: 0px;
    padding: 0px 10px;
    text-align: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    font-size: inherit;
    width: 100%;
}

.Navbar_navbar__uTQDG li button:hover,
.Navbar_navbar__uTQDG ul li:hover button {
    background: bottom center no-repeat #1182ff;
    color: #ffffff;
    text-decoration: none;
}

/* Apenas quando a tela for menor que 768px e estiver na vertical */
@media screen and (max-width: 768px) and (orientation: portrait) {
    .Navbar_navbar__uTQDG {
        position: relative; /* Permite que o menu fique acima do conteúdo */
    }
    .Navbar_navbar__uTQDG li ul.Navbar_active__voVsU {
        display: block; /* Mostra o submenu quando ativo */
    }
    .Navbar_navbar__uTQDG ul {
        flex-direction: column;
        height: auto;
    }

    .Navbar_navbar__uTQDG li {
        width: 100%;
        text-align: center;
        background: #0053ae; /* Adicione esta linha para definir o background */
    }

    .Navbar_navbar__uTQDG li ul {
        position: static;
        display: none;
        width: 100%;
    }

    .Navbar_navbar__uTQDG li:hover ul {
        display: block;
    }
    .Navbar_navbar__uTQDG li a {
        background: #0053ae; /* Adicione esta linha para definir o background dos links */
        color: #ffffff; /* Adicione esta linha para definir a cor do texto dos links */
    }

    .Navbar_navbar__uTQDG li ul li a {
        background: none; /* Remova o background dos links do submenu */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ;kBACc;IACd,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB,EAAE,+CAA+C;IACnE,aAAa,EAAE,qCAAqC;AACxD;AACA;IACI,gBAAgB,EAAE,WAAW;IAC7B,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;AACA;IACI,uCAAuC,EAAE,WAAW;IACpD,WAAW,EAAE,WAAW;IACxB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;;IAEI,2CAA2C;IAC3C,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,aAAa,EAAE,yBAAyB;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ;cACU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,yCAAyC;IACzC,WAAW;IACX,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,uCAAuC,EAAE,WAAW;IACpD,WAAW,EAAE,WAAW;IACxB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,2CAA2C;IAC3C,cAAc;IACd,qBAAqB;AACzB;;AAEA,mEAAmE;AACnE;IACI;QACI,kBAAkB,EAAE,+CAA+C;IACvE;IACA;QACI,cAAc,EAAE,kCAAkC;IACtD;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB,EAAE,kDAAkD;IAC3E;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB,EAAE,4DAA4D;QACjF,cAAc,EAAE,8DAA8D;IAClF;;IAEA;QACI,gBAAgB,EAAE,6CAA6C;IACnE;AACJ","sourcesContent":["@charset \"utf-8\";\n\n.navbar {\n    border: none;\n    border: 0px;\n    margin: 0px;\n    padding: 0px;\n    font: 67.5% \"Lucida Sans Unicode\", \"Bitstream Vera Sans\", \"Trebuchet Unicode MS\", \"Lucida Grande\", Verdana, Helvetica,\n        sans-serif;\n    font-size: 18px;\n    font-weight: bold;\n\n    position: relative; /* Permite que o menu fique acima do conteúdo */\n    z-index: 1000; /* Mantém o menu acima do container */\n}\n.navbar ul {\n    background: #ccc; /*#006633;*/\n    height: 35px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.navbar li {\n    float: left;\n    padding: 0px;\n    margin: 0;\n}\n.navbar li a {\n    background: bottom right no-repeat #ccc; /*#006633;*/\n    color: #000; /*#ffffff;*/\n    display: block;\n    font-weight: normal;\n    line-height: 35px;\n    margin: 0px;\n    padding: 0px 10px;\n    text-align: center;\n    text-decoration: none;\n}\n.navbar li a:hover,\n.navbar ul li:hover a {\n    background: bottom center no-repeat #1182ff;\n    color: #ffffff;\n    text-decoration: none;\n}\n.navbar li ul {\n    background: #0053ae;\n    display: none; /* Escondido por padrão */\n    height: auto;\n    padding: 0px;\n    margin: 0px;\n    border: 0px;\n    position: absolute;\n    /*width:225px;*/\n    z-index: 200;\n    /*top:1em;\n    /*left:0;*/\n}\n\n.navbar li:hover ul {\n    display: block;\n}\n\n.navbar li li {\n    background: bottom left no-repeat;\n    display: block;\n    float: none;\n    margin: 0px;\n    padding: 0px;\n    /*width:225px;*/\n}\n\n.navbar li:hover li a {\n    background: none;\n}\n\n.navbar li ul a {\n    display: block;\n    height: 30px;\n    /*font-size:12px;*/\n    font-style: normal;\n    margin: 0px;\n    padding: 0px 10px 0px 20px;\n    text-align: left;\n    color: #fff;\n}\n\n.navbar li ul a:hover,\n.navbar li ul li:hover a {\n    background: center left no-repeat #39b0e2;\n    border: 0px;\n    color: #fff;\n    text-decoration: none;\n}\n.navbar p {\n    clear: left;\n}\n\n/* formatação do button */\n.navbar li button {\n    background: bottom right no-repeat #ccc; /*#006633;*/\n    color: #000; /*#ffffff;*/\n    display: block;\n    font-weight: normal;\n    line-height: 35px;\n    margin: 0px;\n    padding: 0px 10px;\n    text-align: center;\n    text-decoration: none;\n    border: none;\n    cursor: pointer;\n    font-size: inherit;\n    width: 100%;\n}\n\n.navbar li button:hover,\n.navbar ul li:hover button {\n    background: bottom center no-repeat #1182ff;\n    color: #ffffff;\n    text-decoration: none;\n}\n\n/* Apenas quando a tela for menor que 768px e estiver na vertical */\n@media screen and (max-width: 768px) and (orientation: portrait) {\n    .navbar {\n        position: relative; /* Permite que o menu fique acima do conteúdo */\n    }\n    .navbar li ul.active {\n        display: block; /* Mostra o submenu quando ativo */\n    }\n    .navbar ul {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .navbar li {\n        width: 100%;\n        text-align: center;\n        background: #0053ae; /* Adicione esta linha para definir o background */\n    }\n\n    .navbar li ul {\n        position: static;\n        display: none;\n        width: 100%;\n    }\n\n    .navbar li:hover ul {\n        display: block;\n    }\n    .navbar li a {\n        background: #0053ae; /* Adicione esta linha para definir o background dos links */\n        color: #ffffff; /* Adicione esta linha para definir a cor do texto dos links */\n    }\n\n    .navbar li ul li a {\n        background: none; /* Remova o background dos links do submenu */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__uTQDG`,
	"active": `Navbar_active__voVsU`
};
export default ___CSS_LOADER_EXPORT___;
